// extracted by mini-css-extract-plugin
export default {"applicantForm":"applicant_applicantForm__FmRur"};